import { Avatar } from '@chakra-ui/react';
import appColors from '../../theme/appColors';

function AppAvatar({ src, name, size }) {
  return (
    <Avatar
      size={size}
      name={name}
      src={src}
      bgColor={appColors.brandSecondary['100']}
      color={appColors.brandSecondary['500']}
    />
  );
}

export default AppAvatar;
